module.exports = __webpack_public_path__ + "img/Houdinis_poster.47c832d.jpeg";